import React, { useState } from 'react';
import { Button, FormControl, Form, InputGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ClearSvg } from 'images/clear.svg';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { useHistory } from 'react-router';
import { captcha_client_site_key } from 'constants/const.js'
import ReCAPTCHA from "react-google-recaptcha";
import { LOGIN, PROFILE } from 'constants/routes';
import { logoutUserActionCreator } from 'reducers/auth/auth.actionCreators';


export const DeleteAccountModal = ({ children }) => {
    const history = useHistory();
    const [show, setShow] = useState(false);
    const [captchaScreen, setCaptchaScreen] = useState(true);
    const { t } = useTranslation();
    const user = useSelector(selectAuthUser);
    const dispatch = useDispatch();

    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    };


    const handleDelete = () => {
        console.log('deleting user with ID: ', user.id);
        setShow(false);
        // TODO here we should dispatch an action to delete a user.
        dispatch(logoutUserActionCreator());
        history.push(LOGIN);

    }

    const handleCancel = () => {
        setShow(false);
    }

    const onCaptchaChange = (value) => {
        console.log("Captcha value:", value);
        setCaptchaScreen(false);
    }

    return (
        <>
            <div onClick={handleShow}>
                {children}
            </div>

            <Modal show={show} onHide={handleClose} centered size="md" dialogClassName={'delete-account-modal-container'}>
                <Modal.Header style={{ position: 'relative' }}>
                    <ClearSvg onClick={() => setShow(false)} style={{ position: 'absolute', right: 20 }} />
                    <Modal.Title className="d-flex align-items-center font-size-14">{t('Delete account')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className={'d-flex'}>
                    <div className={'d-flex flex-column justify-content-around overflow-hidden'}>
                        {
                            captchaScreen ? (
                                <>
                                    <div className="d-flex flex-column">
                                        <p className={'text-red font-weight-bold font-size-12'}>{t('This will permanently delete your account!')}</p>
                                    </div>
                                    <div className={'d-flex captcha-container'}>
                                        <div className="captcha-box-wrapper">
                                            {
                                                <ReCAPTCHA
                                                    sitekey={captcha_client_site_key}
                                                    theme={'dark'}
                                                    onChange={onCaptchaChange}
                                                />
                                            }
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="d-flex flex-column">
                                        <p className={'font-size-12 text-gray'}>Are you sure you want permamently delete your account?</p>
                                    </div>

                                    <div className={'d-flex justify-content-between'}>
                                        <ButtonComponent
                                            type={'button'}
                                            btnText={'Cancel'}
                                            onClick={handleCancel}
                                            transparent={false}
                                            customClass={'mt-4 mb-2 py-2 px-4 btn-white custom-save-btn font-size-12'}
                                            bordered={true}
                                        />
                                        <ButtonComponent
                                            type={'button'}
                                            btnText={'Yes Delete'}
                                            onClick={handleDelete}
                                            transparent={false}
                                            customClass={'mt-4 mb-2 py-2 px-4 btn-white custom-save-btn font-size-12 button-background-lightViolet'}
                                        />
                                    </div>
                                </>
                            )
                        }

                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}
